import {injectable} from "inversify";

@injectable()
export default class MemoryLogger {
  public log(name: string = 'default') {
    type MemoryType = {
      usedJSHeapSize: number,
      totalJSHeapSize: number,
      jsHeapSizeLimit: number,
    }

    const memory = (window.performance as unknown as { memory: MemoryType }).memory;

    console.log(`memory::${name}`, {
      used: memory.usedJSHeapSize / 1024 ** 2,
      total: memory.totalJSHeapSize / 1024 ** 2,
      limit: memory.jsHeapSizeLimit / 1024 ** 2,
    });
  }
}
